var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]),_c(_vm.table,{tag:"component",attrs:{"filter":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }